import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {
    CommonServices,
    IntegrationServices,
    PersonalSettingServices,
    ServiceServices
} from '../../../shared/services/src/api';
import {IntegrationName} from '../../../views/main/integration/integration.config';
import {AppUtils, StringUtils} from '../../../shared';
import * as _ from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import { IntegrationType } from '../../../shared/enums/integration-type.enum';
import {LanguageUtils} from '../../../shared/utils/src/language.utils';

@Component({
    selector: 'detail-event-rule-component',
    templateUrl: './detail-event-rule.component.html',
    providers: [ IntegrationServices, ServiceServices],
    styleUrls : [
        '../../../views/main/_style/container.content.scss',
        '../../escalation-rule/rule.component.scss',
        '../../../views/main/_style/page.personalsetting.scss'
    ]
})

export class DetailEventRuleComponent implements OnInit, OnDestroy, OnChanges  {
    @Input() public ruleInfo = [];
    @Input() public isEditable: boolean;
    @Input() public itgrNo: number;
    @Input() public itgrRuleTypeCd: string;
    @Input() public defaultSrcNo: number = 10003 // default 종료;
    @Input() public defaultTrgtNo: number;
    @Input() public routeRuleInfo: any;

    @Input() public isAddRouteRule: boolean;

    @Output() public routCndUse:EventEmitter<any> = new EventEmitter<any>(true);

    ruleIndex = 0;
    routCndUseFlag = false;
    selPopupVal = {
        trgtNo: '',
        trgtNm: '',
        typeCd: 'ROUTTYPE20',
        statCd: ''
    }
    conditionIndex = 0;

    srcOption:any = [];
    targetOption:any = [];
    IntegrationType = IntegrationType;
    IntegrationTypes = ['IRTY10', 'IRTY20']

    public srcEvtConfig: any = {};

    public trgtEvtConfig: any = {};

    constructor(
        private _integrationServices: IntegrationServices,
        private personalSettingServices: PersonalSettingServices,
        private _serviceServices: ServiceServices,
        private _commonServices: CommonServices,
        private translate: TranslateService,
    ) {
    }

    ngOnInit() {
        for (const type of this.IntegrationTypes) {
            this.srcEvtConfig[type] = {
                id: 'srcEvtCnfgList',
                name: 'srcEvtCnfgList',
                option: []
            };
            this.trgtEvtConfig[type] = {
                id: 'trgtEvtCnfgList',
                name: 'trgtEvtCnfgList',
                option: []
            }
        }
        if (typeof this.itgrNo !== 'undefined') {
            this.getItgrEvtList();
        }
        if (this.routeRuleInfo && this.routeRuleInfo.useYn === 'Y') {
            this.routCndUseFlag = true;
            this.routCndUse.emit(true);
        }
        this.selPopupVal.trgtNo = '';
        this.selPopupVal.typeCd = 'ROUTTYPE20';
        this.conditionIndex = 0;

        this.resetOrdrNo();
        this.getServiceRouteMsgSpec();
        this.getOprType();
        this.getUrgencyLevelRuleAction();
        this.getTimeZone();
        this.checkRouteRuleCndInfo();
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: SimpleChanges) {
        // ngoninit 전에 한번 실행됨
        if (typeof this.ruleInfo === 'undefined') {
            this.ruleInfo = [];
        }
        this.resetOrdrNo();

        // if (typeof this.itgrNo !== 'undefined') {
        //     this.getItgrEvtList();
        // }

        const isEditableChange = changes['isEditable'];

        if (isEditableChange && this.isEditable) {
            if (this.ruleInfo.length === 0) {
                this.ruleSetAdd();
            }
        }
        this.checkRouteRuleCndInfo();

    }

    public ruleSetAdd() {
        this.ruleIndex++;
        this.ruleInfo.push({
            ordrNo: this.ruleIndex,
            invalid: false,
            cnfgSrcNo: this.defaultSrcNo,
            cnfgTrgtNo: this.defaultTrgtNo,
            itgrRuleTypeCd: this.itgrRuleTypeCd

        });

        this.resetOrdrNo();
        this.isValidSelectData();

    }

    public ruleSetRemove(event, ordrNo) {
        if (this.ruleInfo.length > 1) {
            _.remove(this.ruleInfo, {ordrNo : ordrNo});
            this.resetOrdrNo();
            // 중복 선택 Validation
            this.isValidSelectData();
        }
    }

    public isValidSelectData(): any {
        let isValid = true;

        // ruleSet의 invalid 값을 초기화 시켜준다.
        for (const ruleSet of this.ruleInfo) {
            ruleSet['invalid'] = false;
        }

        for (let i = 0; i < this.ruleInfo.length; i++) {
            const temp = this.ruleInfo[i]['cnfgSrcNo'];
            for (let j = i + 1; j < this.ruleInfo.length; j++) {
                if (String(temp) === String(this.ruleInfo[j]['cnfgSrcNo'])) {
                    this.ruleInfo[i]['invalid'] = true;
                    this.ruleInfo[j]['invalid'] = true;
                    isValid = false;
                }
            }
        }
        return isValid;
    }

    public srcEvtSelectChanged(event, ordrNo) {
        this.ruleInfo[ordrNo - 1]['cnfgSrcNo'] = event;
        this.isValidSelectData();
    }

    public trgtEvtSelectChanged(event, ordrNo) {
        this.ruleInfo[ordrNo - 1]['cnfgTrgtNo'] = event;
    }

    public resetOrdrNo() {
        this.ruleIndex = 0;

        this.ruleInfo.forEach((ruleSet, index) => {
            index++;
            ruleSet.ordrNo = index;
            this.ruleIndex = index;
            ruleSet.invalid = false;
        });
    }

    public getRuleInfo(): any {
        let routRuleInfo = {
            procRuleNo: this.routeRuleInfo.procRuleNo,
            useYn: this.routCndUseFlag === true ? 'Y' : 'N',
            ruleRoutGrpInfo: [],
        }
        const cndInfo = this.routeRuleInfo.cndInfo || []

        if (this.itgrRuleTypeCd === 'IRTY20' && cndInfo.length) {
            routRuleInfo.ruleRoutGrpInfo.push({
                ordrNo: 1,
                cnnTypeCd: 'RUCDCN10',
                cndLogicTypeCd: this.routeRuleInfo.cndLogicTypeCd,
                ...this.routeRuleInfo,
            });
        } else {
            routRuleInfo = null;
        }
        return {
            useYn: 'Y',
            itgrRuleTypeCd: this.itgrRuleTypeCd,
            ruleCnfgInfo: this.getEventRuleConfigInfo(),
            routRuleInfo: routRuleInfo,
        };
    }

    public getEventRuleConfigInfo(): any {
        const _eventRuleCnfgInfo = [];
        for (const ruleCnfg of this.ruleInfo) {
            const eventRule = {
                cnfgSrcNo: ruleCnfg['cnfgSrcNo'],
                cnfgTrgtNo: ruleCnfg['cnfgTrgtNo']
            };
            _eventRuleCnfgInfo.push(eventRule);
        }
        return _eventRuleCnfgInfo;
    }


    public cndCnnTypeCdSelectConfig = {
        id: 'cndCnnTypeCd',
        name: 'cndCnnTypeCd',
        className: 'full_width',
        option: [
            /*{label: 'MK.01800' , value: ''},*/
            {label: 'MK.01801' , value: 'RUCDCN40'},
            {label: 'MK.01802' , value: 'RUCDCN50'}
        ]
    };

    //서비스 라우팅 메세지 스펙
    public msgSpecSelectConfig = {
        id: 'msgSpecList',
        name: 'msgSpecList',
        className: '',
        option: [
        ]
    };
    public TimezoneTypeSelectConfig: any = {
        id: 'timezoneType',
        name: 'timezoneType',
        defaultOption: {
            useFlag: false,
            label: '',
            value: ''
        },
        option: []
    };
    public getTimeZone() {
        this._commonServices.getCode('TMZN_CD', 'LANG')
            .then(result => {
                if (result.status === 200) {
                    this.TimezoneTypeSelectConfig = {
                        id: 'timezoneType',
                        name: 'timezoneType',
                        defaultOption: {
                            useFlag: false,
                            label: '',
                            value: ''
                        },
                        option: []
                    };

                    this.TimezoneTypeSelectConfig.option = [];

                    result.json().data.forEach(timezone => {
                        this.TimezoneTypeSelectConfig.option.push({
                            label: timezone.dispNm,
                            value: timezone.cdId,
                            tmznOfs: timezone.cdSeq1Val
                        });
                    });
                }
            });

    }
    //서비스 라우팅 연산자 셀렉트
    public oprTypeSelectConfig: any = {
        id: 'oprTypeList',
        name: 'oprTypeList',
        className: '',
        option: [
        ]
    };

    public oprTypeSelectConfigUrgency: any = {
        id: 'oprTypeUrgcList',
        name: 'oprTypeUrgcList',
        className: '',
        option: [
        ]
    };

    public urgencyLevelSelectConfig: any = {
        id: 'urgencyLevelList',
        name: 'urgencyLevelList',
        option: []
    };
    // 이벤트 목록 가져오기
    getItgrEvtList() {
        // src Evt List
        this.getItgrEvtListByItgrNo(0, 'srcEvtConfig');
        this.getItgrEvtListByItgrNo(this.itgrNo, 'trgtEvtConfig');
    }
    setFilteringEvtList(configName, options) {
        for (const option of options) {
            const ruleType = option.itgrRuleType;
            if (!this[configName][ruleType]) {
                this[configName][ruleType] = {
                    id: 'srcEvtCnfgList',
                    name: 'srcEvtCnfgList',
                    option: []
                }
            }
            this[configName][ruleType].option.push({
                label: option.label,
                value: option.value
            });
        }
    }
    getItgrEvtListByItgrNo(itgrApplNo, configName) {
        const options = [];
        this._integrationServices.getItgrEvtListByItgrNo(itgrApplNo).then(result => {
            if (result.status === 200) {
                result.json().data.forEach((_data: any) => {
                    options.push({
                        label: _data.msgId,
                        value: _data.evtCnfgNo,
                        itgrRuleType: _data.itgrRuleType
                    });
                });
                // todo 방정현 비동기 통신 후 어느 시점에 angular model이 업데이트 되는지 알수 없어서 임시처리 함
                this.setFilteringEvtList(configName, options);
            }
        });
    }

    // 동적 이름 표시
    getEventTrgtItgrNm() {
        return this.translate.instant('MK.02019', {
            integrationService:  this.translate.instant(IntegrationName[this.itgrNo])
        });
    }

    oprTypeCdChanged(event, cndRule) {
        cndRule.oprTypeCd = event;
    }

    cndValChanged(cndRule) {
        if (StringUtils.isEmpty(cndRule.cndVal)) {
            cndRule.isInvalidCndVal = true;
        } else {
            cndRule.isInvalidCndVal = false;
        }
    }

    /** 조건 연산자 유형 **/
    getOprType() {
        this._commonServices.getCode('CND_OPR_TYPE_CD?disp=all').then(result => {
            if (result.status === 200) {
                this.oprTypeSelectConfig.option = [];
                this.oprTypeSelectConfigUrgency.option = [];

                result.json().data.forEach((_data: any) => {
                    this.oprTypeSelectConfig.option.push({
                        label: _data.dispNm,
                        value: _data.cdId
                    });

                    if (_data.cdSeq1Val === 'MSGDATA050') {
                        this.oprTypeSelectConfigUrgency.option.push({
                            label: _data.dispNm,
                            value: _data.cdId
                        });
                    }
                });
            }
        });
    }
    routCndUseChange(event) {
        this.routCndUseFlag = event;
        this.routCndUse.emit(event);
        if (!this.routeRuleInfo.cndInfo.length) {
            this.routeRuleInfo.cndInfo = [];
            this.addCondition();
        }
    }
    cndCnnTypeCdChanged(event) {
        // this.timeCndUseFlag = event === '' ? true : false;
        this.routeRuleInfo.cndLogicTypeCd = event;


        // if (event !== '') {
        //     this.addCondition();
        // }
    }
    /** 서비스 라우팅룰 설정에 사용하는 메세지 스펙 조회**/
    getServiceRouteMsgSpec() {
        this._serviceServices.getServiceRouteMsgSpec().then(result => {
            if (result.status === 200) {
                this.msgSpecSelectConfig.option = [];

                result.json().data.forEach((_data: any) => {
                    this.msgSpecSelectConfig.option.push({
                        label: _data.fildFullNm,
                        value: _data.msgSpecFildNo
                    });
                });
            }
        });
    }
    msgSpecFildNoChanged(event, cndRule) {
        cndRule.msgSpecFildNo = Number(event);

        if (cndRule.msgSpecFildNo === 10008) {
            cndRule.cndVal = '10001';
            cndRule.cndValtoNumber = Number(cndRule.cndVal);
            cndRule.oprTypeCd = 'COPR010';
        } else {
            cndRule.cndVal = '';
            cndRule.oprTypeCd = 'COPR090';
        }
    }
    /** Urgency Level 룰 액션 조회**/
    getUrgencyLevelRuleAction() {
        this.personalSettingServices.getUrgency().then(result => {
            if (result.status === 200) {
                this.urgencyLevelSelectConfig.option = [];

                result.json().data.forEach((_data: any) => {
                    this.urgencyLevelSelectConfig.option.push({
                        label: _data.tcktPriNm,
                        value: _data.tcktPriNo
                    });
                });
            }
        });
    }

    getUrgencyLabelNm(val) {
        if (this.urgencyLevelSelectConfig.option > 0) {
            return _.find(this.urgencyLevelSelectConfig.option, {'value': val}).label;
        } else {
            const langCd = LanguageUtils.getLangCode();
            const urgencys = [
                {cd: 10001, ko: '없음',     en: 'None',    zh: '无',  ja: 'なし'},
                {cd: 10006, ko: '매우 높음', en: 'Highest', zh: '紧急', ja: 'とても高い'},
                {cd: 10005, ko: '높음',     en: 'High',    zh: '高',  ja: '高い'},
                {cd: 10004, ko: '보통',     en: 'Medium',  zh: '中',  ja: '普通'},
                {cd: 10003, ko: '낮음',     en: 'Low',     zh: '低',  ja: '低い'},
                {cd: 10002, ko: '매우 낮음', en: 'Lowest',  zh: '较低', ja: 'とても低い'},
            ]

            let retVal;
            switch (langCd) {
                case 'ko': retVal = _.find(urgencys, {'cd': val}).ko; break;
                case 'en': retVal = _.find(urgencys, {'cd': val}).en; break;
                case 'zh': retVal = _.find(urgencys, {'cd': val}).zh; break;
                case 'ja': retVal = _.find(urgencys, {'cd': val}).ja; break;
                default: retVal = _.find(urgencys, {'cd': val}).en; break;
            }
            return retVal;
        }
    }

    addCondition() {
        this.conditionIndex = this.routeRuleInfo.cndInfo.length + 1;
        const newCondition = {
            ordrNo: this.conditionIndex,
            msgSpecFildNo: 10006,
            oprTypeCd: 'COPR090',
            cndVal: '',
            cndValSprtnChaVal: '',
            // msgSpecFildList: []
        };

        this.routeRuleInfo.cndInfo.push(newCondition);
    }
    resetConditionOrdrNo() {
        this.conditionIndex = 0;
        this.routeRuleInfo.cndInfo.forEach((condition, index: number) =>{
            index++;
            condition.ordrNo = index;
            this.conditionIndex = index;
        });
    }
    removeCondition(removeIndex) {
        _.remove(this.routeRuleInfo.cndInfo, {ordrNo: removeIndex});
        this.resetConditionOrdrNo();
    }
    urgencyLevelChange(event, cndRule) {
        cndRule.cndVal = event;
        cndRule.cndValtoNumber = Number(cndRule.cndVal);
    }
    getCndLogicTypeCdName() {
        const configOption = this.cndCnnTypeCdSelectConfig.option.find( o => o.value === this.routeRuleInfo.cndLogicTypeCd )
        return this.translate.instant(configOption ? configOption.label : 'unKnown')
    }
    checkRouteRuleCndInfo() {
        if (this.routeRuleInfo && this.routeRuleInfo.cndInfo && this.routeRuleInfo.cndInfo.length) {
            _.sortBy(this.routeRuleInfo.cndInfo,'ordrNo');
            let checkOrdrNo = 1;
            for (const cnd of this.routeRuleInfo.cndInfo) {
                if (Number(cnd.ordrNo) !== checkOrdrNo) {
                    cnd.ordrNo = checkOrdrNo;
                }
                if (cnd.msgSpecFildNo === 10008) {
                    cnd.cndValtoNumber = Number(cnd.cndVal);
                }
                ++checkOrdrNo;
            }
        } else {
            this.routeRuleInfo = {
                cndInfo: []
            };
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/detail-rule/detail-event-rule.component.ts